import { render, staticRenderFns } from "./DuctPlan.vue?vue&type=template&id=2a48a6d4&scoped=true&"
import script from "./DuctPlan.vue?vue&type=script&lang=js&"
export * from "./DuctPlan.vue?vue&type=script&lang=js&"
import style0 from "./DuctPlan.vue?vue&type=style&index=0&id=2a48a6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a48a6d4",
  null
  
)

export default component.exports